import { ftToCm } from "src/components/Planner/planner/uMath";

/**
 * https://www.vision-doctor.com/en/optical-calculations/calculation-working-distance.html
 * @param {number} sensorSizeMM
 * @param {number} focalLengthMM
 * @param {number} objectSizeMM
 * @return {number}
 */
function getWorkingDistanceMM(sensorSizeMM, focalLengthMM, objectSizeMM) {
  return focalLengthMM * (objectSizeMM / sensorSizeMM + 1);
}

export const MovsenGlobals = {
  // https://www.orangesecurity.com/blog/security-cameras/what-is-the-focal-length-of-a-security-camera-lens/
  camera_props: {
    113: { // focal length 2.8mm - "fish eye"
      viewAngle: 103,
      radiusCM: ftToCm(10),
      startColor: 'rgba(255,0,0,1)',
      endColor: 'rgba(255,0,0,0)'
    },
    114: { // focal length 8mm - wide
      viewAngle: 42,
      radiusCM: ftToCm(40),
      startColor: 'rgba(255,140,0,1)',
      endColor: 'rgba(255,140,0,0)'
    },
    115: { // ubiquiti UVC-G3-AF
      sensorSizeMM: {
        width: 4.8,
        height: 3.6,
        diagonal: 6.0
      }, // UNUSED width of 1/3" sensor
      focalLengthMM: 3.6, // UNUSED
      viewAngle: 72,
      radiusCM: getWorkingDistanceMM(3.6, 3.6, 3600) / 10, //meaning: the ending of the cone is where camera sees 4m vertically
      startColor: 'rgba(65,105,225,1)',
      endColor: 'rgba(65,105,225,0)'
    }
  },
}